import { Typography } from '@mui/material'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

export const BookingListEmpty: FC = () => {
  const { t } = useTranslation()

  return <Typography variant='bodyM'>{t('home.no-bookings')}</Typography>
}
